import { render } from "./item_price_history.vue?vue&type=template&id=e2b6ffd0"
import script from "./item_price_history.vue?vue&type=script&lang=js"
export * from "./item_price_history.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__